module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "functions",
    attrs: {
      "id": "function"
    }
  }, [_c('h2', [_vm._v("多样化的功能支持")]), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.functionData), function(func) {
    return _c('div', {
      staticClass: "function-item"
    }, [_c('div', {
      staticClass: "function-logo",
      class: func.logo
    }), _c('div', {
      staticClass: "function-header"
    }, [_vm._v(_vm._s(func.header))]), _c('p', [_vm._v(_vm._s(func.content))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a13b60f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/functions.vue
// module id = 51
// module chunks = 0